export default __webpack_public_path__ + "images/7831a943561a83e16117bef14e54ebe4-environmentsustainability_small.webp";